import React, { useEffect } from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IOptionsGreekConstraintTableReport } from "../../../Interfaces/optionGreek";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppSelector } from "../../../App/hooks";

const TableUI = ({
  reports,
  sortingType,
  setSortingType,
  onTableRowClick,
  onAction,
}: ITableUI<IOptionsGreekConstraintTableReport>) => {
  const flag = useAppSelector((store) => store.optionGreek.constraintTableFlag);

  useEffect(() => {
    if (flag && onAction) onAction();
  }, [flag]);

  return (
    <CommonTableUI
      reports={reports}
      tableBoxClassName="max-h-[500px]"
      sortingType={sortingType}
      setSortingType={setSortingType}
      onTableRowClick={onTableRowClick}
    />
  );
};

export default TableUI;
